import { createApp } from 'vue'
import { createPinia } from 'pinia'
import '@/output.css'
import '@/style.css'
import App from '@/App.vue'
import { router } from '@/router'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { i18n } from "@/i18n";


;(async () => {
  const store = createPinia()
  const app = createApp(App)
  app.use(store)
  app.use(VueReCaptcha, { siteKey: import.meta.env.VITE_CAPTCHA_SITE_KEY,
    loaderOptions: {
      autoHideBadge: true // Ensures badge is hidden
    }})

  const params = new URLSearchParams(window.location.search);
  const uuid = params.get('uuid');
  if (uuid) {
    localStorage.setItem('uuid', uuid);
  }
  app.use(i18n);
  app.use(router)

  app.mount('#app')

  // Adding Google Analytics for production
  // if (import.meta.env.PROD) {
  //   app.use(VueGtag, { config: {
  //     id: import.meta.env.VITE_GA_MEASUREMENT_ID }
  //   })
  // }
})()
